export default {
  kvText: 'The Shopping Spree Begins!\nGet Ready for Amazing Deals!',
  countdown: {
    start: 'Time Until Event Starts: {time}',
    end: 'Time Until Event Ends: {time}',
  },
  verify: {
    title: 'Account Verification',
    placeholder: 'Please Enter Your Account ID',
    accountId: 'Account ID',
    accountName: 'Account Name',
    login: 'Login',
    confirm: 'Please confirm your account information',
    switchAccount: 'Re-enter',
  },
  plaza: 'Shopping Plaza',
  desc: 'Go to the online Top Up page [{clickHere}]. For every 100 Rainbow Diamonds topped up, you will receive 1 Shopping Voucher. Use your Shopping Vouchers to purchase amazing rewards in the Shopping Plaza!',
  clickHere: 'Click Here',
  eventTime: 'Event Period: Nov 6, 2026, 00:00–Nov 15, 2026, 23:59 (GMT+7)\nThe reward claim period ends on Nov 22, 2026, at 23:59 (GMT+7).',
  remaining: 'Remaining Shopping Vouchers: {n}',
  remainingLabel: 'Remaining Shopping Vouchers:',
  goods: {
    hotDeals: 'Hot Deals',
    dailyDeals: 'Daily Deals',
    viewDaily: 'Daily Deals List',
    price: '{n} Shopping Vouchers',
    purchase: 'Purchase',
    remainTimes: 'Remaining Purchase Attempts: {n}',
    notEnoughVoucher: 'Not Enough Shopping Vouchers',
    soldOut: 'Sold Out',
    max: 'MAX',
    confirm: 'Are you sure you want to use {n} Shopping Vouchers to purchase {name}?',
    success: 'Purchase successful. Please log in to the game and check your in-game mailbox.',
    history: 'Purchase History',
    spent: 'Shopping Vouchers Spent',
    details: 'Purchase Details',
    time: 'Purchase Time',
    expired: 'The item you selected has expired. Please refresh the page and select it again.',
    notEnoughDesc: "You don't have enough Shopping Vouchers. Top Up Rainbow Diamonds to get more Shopping Vouchers.",
  },
  milestone: {
    allAchieved: 'You can claim all rewards',
    subtitle: 'Spend enough Shopping Vouchers to earn a Deluxe Chest!',
    topUp: 'Top Up Now',
    history: 'Reward History',
    claimAll: 'Claim All',
    nextTip: 'Spend {n} more Shopping Vouchers to claim the next reward',
    obtained: 'Obtained',
    claimable: 'Available to Claim',
    notAchieved: 'Not Achieved',
    spend: 'Spend {n} Shopping Vouchers',
    header: 'Milestone',
    rewardDetails: 'Reward Details',
    claimTime: 'Claim Time',
    claimSuccess: 'Claim Successful!',
    claimAllSuccessDesc: 'All available rewards claimed!\nView the details in {history}.',
    claimSuccessDesc: 'Item claimed successfully! Log in to the game to collect your reward from the in-game mailbox!',
  },
  common: {
    empty: 'No records yet',
    confirm: 'Confirm',
    cancel: 'Cancel',
  },
  rule: {
    title: 'Event Rules',
    content: [
      '1. During the event, top up Rainbow Diamonds through the Official Top-Up Center to receive Shopping Vouchers. Earn 1 Shopping Voucher for every 100 Rainbow Diamonds topped up.',
      '2. Spend Shopping Vouchers at the Shopping Plaza to redeem various items, including the event-exclusive Avatar Frame – Shopping Pro.\nYou can get [Daily Deals] - valuable rewards for just 1 Shopping Voucher, which will refresh on everyday 00:00(GMT+7).',
      '3. Spending Shopping Vouchers increases your shopping progress. Reach the specified milestones to claim the corresponding Milestone Chests.',
      '4. After the event ends, any unused Shopping Vouchers will expire, so please use them in time. Unclaimed milestone rewards will be automatically sent to you via in-game mail.',
      '5. Please participate in the event through the officially designated third-party payment channel. Eligibility and rewards related to refunded transactions, abnormal orders, or rule violations will be handled according to the event rules.',
      '6. If you have any questions, please contact us via the Customer Service button on this page or through the in-game Customer Support channel.',
    ].join('\n\n'),
  },
  status: {
    notStart: 'The event has not started yet',
    ended: 'The event has ended',
  },
}
